// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
table {
  width: 100%;
  border-collapse: separate;
  margin: auto;
}

th, td {
  border: solid 1px #77c9ff;
  padding: 8px;
  text-align: left;
}

th {
  background-color: #77c9ff; /* Couleur bleue pour l'arrière-plan de l'en-tête */
  color: #fff; /* Couleur du texte pour l'en-tête */
}

.blank {
  border: none;
}

#total {
  float: right;
}

/* Ajoutez un peu d'espace en bas de la facture */`, "",{"version":3,"sources":["webpack://./src/app/components/Coach/bills/form-bills/form-bills.component.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAEd;EACE,WAAA;EACA,yBAAA;EACA,YAAA;AAAJ;;AAGE;EACE,yBAAA;EACA,YAAA;EACA,gBAAA;AAAJ;;AAGE;EACE,yBAAA,EAAA,mDAAA;EACA,WAAA,EAAA,oCAAA;AAAJ;;AAIE;EACE,YAAA;AADJ;;AAGE;EACE,YAAA;AAAJ;;AAGE,iDAAA","sourcesContent":["\r\n  \r\n  table {\r\n    width: 100%;\r\n    border-collapse: separate;\r\n    margin: auto;\r\n  }\r\n\r\n  th, td {\r\n    border: solid 1px #77c9ff;\r\n    padding: 8px;\r\n    text-align: left;\r\n  }\r\n  \r\n  th {\r\n    background-color: #77c9ff; /* Couleur bleue pour l'arrière-plan de l'en-tête */\r\n    color: #fff; /* Couleur du texte pour l'en-tête */\r\n  }\r\n \r\n\r\n  .blank{\r\n    border: none;\r\n  }\r\n  #total {\r\n    float: right;\r\n  }\r\n  \r\n  /* Ajoutez un peu d'espace en bas de la facture */"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
